<script>
import forminput from "../../FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametreHedefTanim from "@/models/StrPerfTablolarDetayParametreHedefTanim"; 
export default {
  mixins: [Api, Sabit, StrPerfTablolarDetayParametreHedefTanim],
  props: ["Id", "AddEdit","Tip"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,

  },
  watch: {
    Id() {
        this.FormData = this.Id;
      
    },
    Tip(){
      if(this.Tip == 'AltHedefAdd'){
        this.FormData = this.StrPerfTablolarDetayParametreHedefTanimData
        this.FormData.Ustid = this.Id;
      }
    }
    


  },
  methods: {
    Get(){
      
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        

        if (this.AddEdit == "Add") { 
           this.$delete(this.FormData, "Id");
              this.Post("StrPerfTablolarDetayParametreHedefTanim", this.FormData).then((res) => { 
                if (res) {       
                    this.$bvModal.hide("StrPerfTablolarDetayParametreHedefTanim");
                    this.$emit("TableUpdate");
                }
              });
        } else {
         
         this.Update("StrPerfTablolarDetayParametreHedefTanim", this.FormData).then((res) => {
              if (res) {
                
                this.$bvModal.hide("StrPerfTablolarDetayParametreHedefTanim");
                this.$emit("TableUpdate");
              }
         });

        }
      }
    },
  },
};
</script>
<template>


  <Loader>

  
    <b-modal
      id="StrPerfTablolarDetayParametreHedefTanim"
      size="lg"
       :title="this.AddEdit == 'Edit' ? $t('StrPerfTablolarDetayParametreHedefTanim.AddEdit.FormTitleEdit')
          : $t('StrPerfTablolarDetayParametreHedefTanim.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >

  <Form  @submit.prevent="onSubmit" > 

                        <div class="row">
                            <div class="col-md-12">

                               <forminput
                                  :title_position="'mb-3'"
                                  :labels_lg="3"
                                  :FormDataType="FormDataType.Hedefadi"
                                  :Value="FormData.Hedefadi"
                                  :v="$v.FormData.Hedefadi"
                                  @input="FormData.Hedefadi = $event"
                                />  
                          

                            </div>
                            <div class="col-md-12" v-if="FormData.Ustid != null">

                                <forminput
                                  :title_position="'mb-3'"
                                  :labels_lg="3"
                                  :min="'0'"
                                  :max="'999999999'"
                                  :FormDataType="FormDataType.Sira"
                                  :Value="FormData.Sira"
                                  :v="$v.FormData.Sira"
                                  @input="FormData.Sira = $event"
                                />  
                                </div>

                        </div>
                       
                            <button class="btn btn-primary"  type="submit" >{{ $t("StrPerfTablolarDetayParametreHedefTanim.AddEdit.Button") }}</button> 

                          </Form>                       
                       


    </b-modal>
  </Loader>
</template>
